import {useSubscription} from '@apollo/client';
import {ON_NOTIFICATION_SUBSCRIPTION} from 'api';
import {useAlert} from 'hooks/useAlert'; // Custom alert hook
import {NotificationPayLoad} from 'models';
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {sessionSelector} from 'store/auth/sessionSlice';
import {triggerRefresh} from 'store/notification/notificationSlice';

export const GlobalNotificationListener = () => {
    const dispatch = useDispatch();
    const {invokeAlert, invokeNotifications} = useAlert();
    const {userId} = useSelector(sessionSelector);
    const {data, error} = useSubscription<{onNotification: NotificationPayLoad}>(ON_NOTIFICATION_SUBSCRIPTION, {
        variables: {userId: userId},
        fetchPolicy: 'no-cache',
        skip: !userId,
        onError: error => {
            console.error('WebSocket Error:', {
                status: (error.networkError as any)?.statusCode,
                message: error.networkError?.message,
            });
        },
    });

    // Handle new data in a useEffect
    useEffect(() => {
        if (data?.onNotification) {
            dispatch(triggerRefresh());
            invokeNotifications(data.onNotification);
        }
    }, [data, dispatch, invokeNotifications]);

    // Handle error in a useEffect
    useEffect(() => {
        if (error) {
            console.error('Subscription connection error:', error);
            invokeAlert('Failed to connect to real-time notifications');
        }
    }, [error, invokeAlert]);

    return null;
};
